import { useEffect, useRef } from 'react'

/**
 * Hook para manejar efectos asíncronos con control de montaje
 * Evita actualizar estados si el componente se desmontó durante la operación async
 *
 * @param asyncFn - Función asíncrona que recibe una función para verificar si el componente está montado
 * @param dependencies - Array de dependencias para el useEffect
 */
export function useMountedEffect(
    asyncFn: (isMounted: () => boolean) => Promise<void>,
    dependencies: React.DependencyList
): void {
    const mountedRef = useRef(true)

    useEffect(() => {
        mountedRef.current = true
        const isMounted = () => mountedRef.current

        asyncFn(isMounted)

        return () => {
            mountedRef.current = false
        }
    }, dependencies)
}
